import React, { FC } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import { useAssessmentPortalState } from '../../../assessment-portal';
import FeeEstimatePage from '../fee-estimate-page';
import type { AdhdFlowState } from '../../types/flow';

const FeeEstimateStep: FC<StepPageProps> = ({ defaultValues, onBack, onNext }) => {
  const { flowState } = useAssessmentPortalState<AdhdFlowState>();

  return (
    <FeeEstimatePage
      defaultValues={defaultValues}
      patientState={flowState.patientInfo?.state || ''}
      medicareType={flowState.patientInfo?.medicareType || ''}
      onBack={onBack}
      onNext={onNext}
    />
  );
};

export default FeeEstimateStep;
